// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateRegion_closeButton__2E7CB"};